<script setup lang="ts">
import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {RehabilitatedPersonsAnalyticProps} from "@/types/analytics";

defineProps<RehabilitatedPersonsAnalyticProps>();
</script>

<template>
  <div class="params">
    <div class="params__wrapper">
      <StatBlock
        title="число лиц, реабилитированных на стадии следствия и оправданных судом"
        :value="analyticData.totalData?.persons_acquitted?.value"
        :percent="analyticData.totalData?.persons_acquitted?.percent_to_previous"
        :is-appg="false"
        :is-main="true"
      />
      <StatBlock
        title="из них содержалось под стражей"
        :value="analyticData.totalData?.persons_detained_rehabilitated?.value"
        :percent="analyticData.totalData?.persons_detained_rehabilitated?.percent_to_previous"
        :is-appg="false"
      />
    </div>

    <StatBlock
      title="число лиц, в отношении которых уголовное преследование прекращено по реабилитирующим основаниям"
      :value="analyticData.totalData?.persons_rehabilitated?.value"
      :percent="analyticData.totalData?.persons_rehabilitated?.percent_to_previous"
      :is-appg="false"
    />

    <DynamicByMonth
      :active-type="activeType"
      :selected-region="selectedRegion"
      :selected-district="selectedDistrict"
      :dynamic="analyticData.monthlyDynamic"
    />
    <template v-if="activeType !== 'region'">
      <RegionTop
        sort-order="desc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topDescending"
      />
      <RegionTop
        sort-order="asc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topAscending"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.params {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    margin-top: auto;
  }
}
</style>